import { useQuery } from "@tanstack/react-query";
import { getGA4Properties, getGSCSites } from "../../api/analytics";
import { analyticsWebsites } from "../../api/analyticsWebsites";
import { analyticsKey, type AnalyticsScope } from "./queryKeys";
export function useConnectionResources(scope: AnalyticsScope) {
  return {
    ga4: useQuery({
      queryKey: analyticsKey(scope, "resources", "ga4"),
      queryFn: getGA4Properties,
      staleTime: 60000,
    }),
    gsc: useQuery({
      queryKey: analyticsKey(scope, "resources", "gsc"),
      queryFn: getGSCSites,
      staleTime: 60000,
    }),
    websites: useQuery({
      queryKey: analyticsKey(scope, "websites", "resource-map"),
      queryFn: ({ signal }) =>
        analyticsWebsites.list({ page_size: 100 }, signal),
      staleTime: 30000,
    }),
  };
}
